async function getFacilities() {
    let facilities = await fetch(`${process.env.API_URL}GetFacilities`);
    let json = await facilities.json();
    return json;
}
export default getFacilities;
